/**
 * Množstvo položky denného menu z nastavení produktu:
 * ak má vyplnenú váhu (productParameters.weightKg, v kg) → gramy ("300 g"),
 * inak ak má objem (productParameters.volumeLiters, v litroch) → litre ("0.5 l").
 * Používa web export aj obrazovky.
 */

/** kg → "300 g" (prázdny string ak nie je platná váha). */
export function formatWeightGrams(weightKg) {
  const num = typeof weightKg === "number" ? weightKg : parseFloat(weightKg);
  if (!Number.isFinite(num) || num <= 0) return "";
  return `${Math.round(num * 1000)} g`;
}

/** litre → "0.5 l" (prázdny string ak nie je platný objem). */
export function formatVolumeLiters(volumeLiters) {
  const num =
    typeof volumeLiters === "number" ? volumeLiters : parseFloat(volumeLiters);
  if (!Number.isFinite(num) || num <= 0) return "";
  return `${parseFloat(num.toFixed(2))} l`;
}

/** Váha (gramy) má prednosť pred objemom (litre). */
export function formatItemQuantity(item) {
  return (
    formatWeightGrams(item?.weightKg) || formatVolumeLiters(item?.volumeLiters)
  );
}
